import React from "react"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material"

import IconClose from "assets/icons/close.svg"
import Button from "components/ui/Button"
import Image from "components/ui/Image"

type Props = React.HTMLAttributes<HTMLButtonElement> & {
  onClick: () => void
}

const ModalCloseComponent = ({ onClick, ...restProps }: Props) => {
  const { t } = useTranslation()

  return (
    <Close onClick={onClick} {...restProps}>
      <Image
        src={IconClose}
        alt={t("common.close")}
        title={t("common.close")}
      />
    </Close>
  )
}

export default ModalCloseComponent

const Close = styled(Button)(({ theme }) => ({
  background: "rgba(172, 172, 172, 0.1)",
  borderRadius: "50px",
  height: "32px",
  lineHeight: "34px",
  margin: "0",
  padding: "0",
  textAlign: "center",
  width: "32px",
  position: "absolute",
  top: "0",
  right: "35px",
  zIndex: 10,
  "&:active": {
    opacity: "0.5",
  },
  [theme.breakpoints.down("lg")]: {
    top: "16px",
    right: "16px",
  },
}))
